if (!customElements.get('yns-homepage-mobile-cta')) {
  customElements.define(
    'yns-homepage-mobile-cta',
    class YnsHomepageMobileCTA extends HTMLElement {
      constructor() {
        super();
        this.mobileMq = window.matchMedia('(max-width: 749px)');
        this.heroVisible = true;
        this.footerVisible = false;
        this.drawerOpen = false;
      }

      connectedCallback() {
        // Only run on homepage at phone width
        const isHomepage = document.body.classList.contains('template-index');
        if (!isHomepage || !this.mobileMq.matches) {
          return;
        }

        // Hero element — observe to hide CTA when hero is on screen
        const hero = document.querySelector('.yns-hero, .yns-hero-section, .yns-hero-wrapper');
        if (hero) {
          this.heroObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.heroVisible = entry.isIntersecting;
                this.updateVisibility();
              });
            },
            { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
          );
          this.heroObserver.observe(hero);
        } else {
          // No hero found — make CTA visible after small scroll
          this.heroVisible = false;
        }

        // Footer + final CTA observer — hide our sticky bar when those are in view
        const footer = document.querySelector('.yns-final-cta, footer.footer, footer');
        if (footer) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.footerVisible = entry.isIntersecting;
                this.updateVisibility();
              });
            },
            { threshold: 0 }
          );
          this.footerObserver.observe(footer);
        }

        // Cart drawer state observer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          this.drawerObserver = new MutationObserver(() => {
            this.drawerOpen = cartDrawer.classList.contains('active');
            this.updateVisibility();
          });
          this.drawerObserver.observe(cartDrawer, {
            attributes: true,
            attributeFilter: ['class'],
          });
        }

        // Respond to viewport resize
        this.mobileMq.addEventListener('change', () => this.updateVisibility());

        // Initial check after first paint
        requestAnimationFrame(() => this.updateVisibility());
      }

      disconnectedCallback() {
        if (this.heroObserver) this.heroObserver.disconnect();
        if (this.footerObserver) this.footerObserver.disconnect();
        if (this.drawerObserver) this.drawerObserver.disconnect();
      }

      updateVisibility() {
        if (!this.mobileMq.matches) {
          this.removeAttribute('data-state');
          return;
        }
        const shouldShow = !this.heroVisible && !this.footerVisible && !this.drawerOpen;
        if (shouldShow) {
          this.removeAttribute('hidden');
          this.setAttribute('data-state', 'visible');
        } else {
          this.setAttribute('data-state', 'hidden');
        }
      }
    }
  );
}
